// this is an autogenerated file from App/Account/Content/Settings/Content/FeatureFlags/Content/mutation-migrate-reminders.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_FeatureFlags_Content{
  appt_reminders_migrate {
    ok
    message
  }
}

`